import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-ys-canvas">
        <div className="ys-spinner" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin" && !(user.permissions && user.permissions.length))
    return <Navigate to="/" replace />;
  return children;
}
